"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllDistributeurVariantsCsv = void 0;
const routes_1 = require("../../routes");
const getAllDistributeurVariantsCsv = (client) => async (params) => {
    const response = await client.get(routes_1.ENDPOINTS.GET_ALL_DISTRIBUTOR_VARIANTS.applyParams(params));
    return response.data;
};
exports.getAllDistributeurVariantsCsv = getAllDistributeurVariantsCsv;
